import { render, staticRenderFns } from "./tableCom.vue?vue&type=template&id=a60fdaf4&scoped=true&"
import script from "./tableCom.vue?vue&type=script&lang=js&"
export * from "./tableCom.vue?vue&type=script&lang=js&"
import style0 from "./tableCom.vue?vue&type=style&index=0&id=a60fdaf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60fdaf4",
  null
  
)

export default component.exports